module.exports = __webpack_public_path__ + "img/创建标签3.ef409a83.svg";